import { FunctionComponent } from 'react';

import { VisitDiagnosis } from '@dreryk/egabinet-visit-frontend-api';

import { DiseaseItem } from './DiseaseItem/DiseaseItem';
import { StyledDiseaseItemList } from './StyledDiseaseItemList';

type DiseaseCellListProps = {
   readonly diagnoses: VisitDiagnosis[];
};

export const DiseaseItemList: FunctionComponent<DiseaseCellListProps> = (props) => {
   return (
      <StyledDiseaseItemList>
         {props.diagnoses.map((diagnosis) => (
            <DiseaseItem name={diagnosis.name} code={diagnosis.icd10Code} main={diagnosis.main} key={diagnosis.id} />
         ))}
      </StyledDiseaseItemList>
   );
};
